export default "__VITE_ASSET__Cmhrqmb2__"